module.exports = __webpack_public_path__ + "media/images/icons/interview-preparation-52e376b970b344cdd5e01e5644f41c0d.svg";